module.exports = __webpack_public_path__ + "img/C03TechCallOfTheStag_ua.2161360e.webp";